'use strict';

var _upperFirst2 = require('lodash/upperFirst');

var _upperFirst3 = _interopRequireDefault(_upperFirst2);

var _forEach2 = require('lodash/forEach');

var _forEach3 = _interopRequireDefault(_forEach2);

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _functionNames = require('./functionNames');

var _functionNames2 = _interopRequireDefault(_functionNames);

var _eventNames = require('./eventNames');

var _eventNames2 = _interopRequireDefault(_eventNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YouTubePlayer = undefined;

YouTubePlayer = {};

/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * @param {Sister} emitter
 * @returns {Object}
 */
YouTubePlayer.proxyEvents = function (emitter) {
    var events = undefined;

    events = {};

    (0, _forEach3.default)(_eventNames2.default, function (eventName) {
        var onEventName = undefined;

        onEventName = 'on' + (0, _upperFirst3.default)(eventName);

        events[onEventName] = function (event) {
            emitter.trigger(eventName, event);
        };
    });

    return events;
};

/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @param {Promise} playerAPIReady Promise that resolves when player is ready.
 * @returns {Object}
 */
YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
    var functions = undefined;

    functions = {};

    (0, _forEach3.default)(_functionNames2.default, function (functionName) {
        functions[functionName] = function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return playerAPIReady.then(function (player) {
                return player[functionName].apply(player, args);
            });
        };
    });

    return functions;
};

exports.default = YouTubePlayer;
module.exports = exports['default'];
//# sourceMappingURL=YouTubePlayer.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/youtube-player/dist/YouTubePlayer.js
 ** module id = 420
 ** module chunks = 0
 **/